import { Immutable } from "immer";
import React from "react";

type IProps = Immutable<{
    value: string | null;
}>;

/**
 * Port of `product_compare_print_only_block.html` — raw-injects the
 * server-rendered (already `.rich-text`-wrapped) richtext HTML into a
 * `.print-only-block` section. Used by both the standalone block wrapper
 * (which passes the pre-rendered `value.source|richtext` string) and the
 * consolidated stearns `ProductComparePageBodyTemplate`.
 */
export const ProductComparePrintOnlyBlock = (
    props: IProps,
): React.JSX.Element => {
    return (
        <section
            className="print-only-block"
            dangerouslySetInnerHTML={{ __html: props.value ?? "" }}
        />
    );
};
